import { render, staticRenderFns } from "./authorizedClients.vue?vue&type=template&id=5485c8a9&scoped=true"
import script from "./authorizedClients.vue?vue&type=script&lang=js"
export * from "./authorizedClients.vue?vue&type=script&lang=js"
import style0 from "./authorizedClients.vue?vue&type=style&index=0&id=5485c8a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5485c8a9",
  null
  
)

export default component.exports